import { z } from 'zod';
import { meta } from '../meta';

export const TextPropsSchema = z.object({
  content: z.string().default('双击编辑文本').meta(meta({ label: '内容', setter: 'textarea' })),
  fontSize: z.number().min(10).max(120).default(16).meta(meta({ label: '字号', setter: 'slider', min: 10, max: 120, step: 1 })),
  color: z.string().default('#333333').meta(meta({ label: '颜色', setter: 'color' })),
  fontWeight: z.enum(['normal', 'bold']).default('normal').meta(meta({
    label: '字重', setter: 'radio',
    options: [{ label: '常规', value: 'normal' }, { label: '加粗', value: 'bold' }],
  })),
  align: z.enum(['left', 'center', 'right']).default('left').meta(meta({
    label: '对齐', setter: 'radio',
    options: [{ label: '左', value: 'left' }, { label: '中', value: 'center' }, { label: '右', value: 'right' }],
  })),
  lineHeight: z.number().min(0.8).max(3).default(1.5).meta(meta({ label: '行高', setter: 'slider', min: 0.8, max: 3, step: 0.1 })),
  letterSpacing: z.number().min(-5).max(30).default(0).meta(meta({ label: '字距', setter: 'slider', min: -5, max: 30, step: 0.5 })),
  fontFamily: z.string().default('').meta(meta({ label: '字体', setter: 'font' })),
});

export type TextProps = z.infer<typeof TextPropsSchema>;
